import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { getAlerts } from "../services/https/alerts";

import { NotificationResponse } from "../interfaces/alerts";
import { clearLocalStorage } from "../helpers";

interface NotificationThunkType {
  notifications: NotificationResponse["data"];
}

const initialState = {
  notifications: [] as NotificationResponse["data"],
};

export const alertThunk = createAsyncThunk("alerts/getAlerts", async () => {
  const res: { data: NotificationResponse; status: number } = await getAlerts();
  return res.data.data;
});

const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    setAlerts: (state, action: PayloadAction<NotificationThunkType>) => {
      state = action.payload;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(alertThunk.fulfilled, (state, action) => {
      if (action.payload) {
        state.notifications = action.payload;
      } else {
        clearLocalStorage();
      }
    });
    builder.addCase(alertThunk.pending, (state) => {});
    builder.addCase(alertThunk.rejected, (state) => {});
  },
});

// Export the actions
export const { setAlerts } = alertSlice.actions;

// Export the reducer
export default alertSlice.reducer;
